import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "w-full flex flex-col absolute top-0 left-0 right-0 bottom-0"
};
const _hoisted_2 = {
  class: "grow w-full px-2 overflow-y-scroll"
};
import Pagination from "@/modules/vue/components/Pagination.vue";
import { TransitionFade } from "@morev/vue-transitions";
export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalPaginator',
  props: {
    empty: {
      type: Boolean
    },
    canGoBack: {
      type: Boolean
    },
    canGoForward: {
      type: Boolean
    }
  },
  emits: ['back', 'forward'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const currentPage = computed(() => props.canGoBack ? 2 : 1);
    const pageCount = computed(() => props.canGoForward ? currentPage.value + 1 : currentPage.value);
    const showPrevPage = () => props.canGoBack && emit('back');
    const showNextPage = () => props.canGoForward && emit('forward');
    const refreshing = ref(false);
    const onChange = page => {
      page < currentPage.value ? showPrevPage() : showNextPage();
      // for transition effect
      refreshing.value = true;
      nextTick(() => refreshing.value = false);
    };
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _directive_swipe_right = _resolveDirective("swipe-right");
      const _directive_swipe_left = _resolveDirective("swipe-left");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(TransitionFade), {
        mode: "out-in",
        duration: 500
      }, {
        default: _withCtx(() => [!refreshing.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [__props.empty ? _renderSlot(_ctx.$slots, "empty", {
          key: 0
        }, () => [_createVNode(_component_NEmpty, {
          description: _ctx.$t('no_entries')
        }, null, 8, ["description"])]) : _renderSlot(_ctx.$slots, "default", {
          key: 1
        })], 64)) : _createCommentVNode("", true)]),
        _: 3
      })])), [[_directive_swipe_right, showPrevPage], [_directive_swipe_left, showNextPage]]), _renderSlot(_ctx.$slots, "pagination", {}, () => [_createVNode(Pagination, {
        "model-value": _unref(currentPage),
        "page-count": _unref(pageCount),
        "onUpdate:modelValue": onChange
      }, _createSlots({
        _: 2
      }, [_ctx.$slots.display ? {
        name: "display",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "display")])
      } : undefined]), 1032, ["model-value", "page-count"])])]);
    };
  }
});